import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8c1442f6")
const _hoisted_1 = { class: "p-grid p-m-6" }
const _hoisted_2 = { class: "p-md-12 p-lg-6 p-p-5" }
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "p-col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Título*", -1)
const _hoisted_6 = { class: "p-col-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Autor*", -1)
const _hoisted_8 = { class: "p-col-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "Puesto", -1)
const _hoisted_10 = { class: "p-col-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Empresa", -1)
const _hoisted_12 = { class: "p-col-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Hashtags*", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Recuerda comenzar cada hashtag con un #")
const _hoisted_15 = { class: "p-md-12 p-lg-6 p-p-5" }
const _hoisted_16 = { class: "p-grid" }
const _hoisted_17 = { class: "p-col-12" }
const _hoisted_18 = { class: "p-grid" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Adjuntar imagen*")
], -1)
const _hoisted_20 = { class: "p-col-12 p-inputtext p-text-right p-d-flex p-ai-center p-jc-between" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Seleccionar imagen")
const _hoisted_22 = { class: "p-col-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "Link del video*", -1)
const _hoisted_24 = { class: "p-col-12" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Asignar categoría* ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode()
const _hoisted_29 = {
  key: 0,
  class: "p-col-12 categoryInput"
}
const _hoisted_30 = { class: "p-grid" }
const _hoisted_31 = ["for"]
const _hoisted_32 = { class: "p-col-12" }
const _hoisted_33 = { class: "p-col-12" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Todos los campos con * son necesarios para publicar el video")
const _hoisted_35 = { class: "p-col-12 p-d-flex p-jc-end" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_spam = _resolveComponent("spam")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InputText, {
            modelValue: _ctx.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.title = $event)),
            class: "inputText",
            id: "new-title",
            placeHolder: "Ingresar título"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            modelValue: _ctx.author,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.author = $event)),
            class: "inputText",
            id: "new-title",
            placeHolder: "Ingresar"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_InputText, {
            modelValue: _ctx.position,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.position = $event)),
            class: "inputText",
            id: "new-title",
            placeHolder: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_InputText, {
            modelValue: _ctx.company,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.company = $event)),
            class: "inputText",
            id: "new-title",
            placeHolder: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_Textarea, {
            onKeydown: [
              _withKeys(_ctx.addTag, ["enter"]),
              _withKeys(_ctx.addTag, ["space"])
            ],
            class: "inputText",
            id: "new-title",
            placeHolder: "#"
          }, null, 8, ["onKeydown"]),
          _createVNode(_component_spam, { class: "spam" }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hashtags, (hashtag, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "p-col-fixed",
            key: hashtag
          }, [
            _createVNode(_component_Tag, {
              class: "delete",
              icon: "pi pi-times",
              value: hashtag,
              onClick: ($event: any) => (_ctx.removeTag(index))
            }, null, 8, ["value", "onClick"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_ctx.imageName === '')
                ? (_openBlock(), _createBlock(_component_spam, {
                    key: 0,
                    class: "p-f-1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_spam, {
                    key: 1,
                    class: "p-f-1 p-text-left"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.imageName), 1)
                    ]),
                    _: 1
                  })),
              _createVNode(_component_FileUpload, {
                class: "upload",
                name: "file",
                mode: "basic",
                accept: "image/*",
                chooseLabel: "Adjuntar",
                customUpload: true,
                auto: true,
                onUploader: _ctx.onUpload,
                onUpload: _ctx.onUploaded
              }, null, 8, ["onUploader", "onUpload"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_InputText, {
            modelValue: _ctx.link,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.link = $event)),
            class: "inputText",
            id: "new-title",
            placeHolder: "Ingresar título"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("h3", null, [
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeShow && _ctx.changeShow(...args)))
            }, "Nueva categoría")
          ]),
          (_ctx.showCategory)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("i", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeShow && _ctx.changeShow(...args))),
                  class: "pi pi-times categoryInputIcon"
                }),
                _createVNode(_component_Button, {
                  onClick: _ctx.addCategoryLocal,
                  label: "Guardar",
                  class: "p-button-text purple-icon categoryInputButton"
                }, null, 8, ["onClick"]),
                _createVNode(_component_InputText, {
                  type: "text",
                  fullwidth: "",
                  modelValue: _ctx.newCategory,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.newCategory = $event)),
                  placeholder: "Nombre",
                  class: "categoryInputText"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "p-col p-field-checkbox",
                key: category.key
              }, [
                _createVNode(_component_Checkbox, {
                  id: category.key,
                  name: "category",
                  disabled: _ctx.selectedCategories.length > 0 && _ctx.selectedCategories[0] !== category,
                  value: category,
                  modelValue: _ctx.selectedCategories,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedCategories = $event))
                }, null, 8, ["id", "disabled", "value", "modelValue"]),
                _createElementVNode("label", {
                  for: category.key
                }, _toDisplayString(category.name), 9, _hoisted_31)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(_component_Divider, { class: "divider" })
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_spam, { class: "spam" }, {
        default: _withCtx(() => [
          _hoisted_34
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateVideo(false))),
          class: "p-button-link",
          icon: "pi pi-save",
          label: "Guardar"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateVideo(true))),
          disabled: _ctx.disablePublish,
          label: "Publicar",
          class: "p-button"
        }, null, 8, ["disabled"])
      ])
    ])
  ]))
}